export default "__VITE_ASSET__BeLjM2kU__"